import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import AboutSection from '@/pages/home/components/AboutSection';
import ProductsSection from '@/pages/home/components/ProductsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import ContactSection from '@/pages/home/components/ContactSection';

export default function Home() {
  return (
    <main className="font-inter antialiased">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <FeaturesSection />
      <ContactSection />
    </main>
  );
}
